<div id="noprint">
    <p>The Office of Finance is now offering a Paperless Statement Program. This program will provide an opportunity to help the environment, reduce costs, and provide easy on-line access to your account's notifications.&nbsp; Click below to enroll in the Paperless Statement Program.
    </p>
    <div class="row">
        <div class="col-md-12 text-center">
            <a [href]="WEB_EOS_URL" src="content/images/Go_Green.jpg" target="_blank"><img src="content/images/Go_Green.jpg"/></a>
        </div>
    </div>
</div>